import Icon from "@/v2-ui/icon"
import Tooltip from "@/v2-ui/tooltip"
import type { SidebarInfo } from "@/v2-backoffice-client/translation/sidebar/translation.sidebar.utils"

export type TranslationSidebarInfoProps = SidebarInfo

function TranslationSidebarInfo(props: TranslationSidebarInfoProps) {
  const { title, body } = props
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <span
          className="translation-sidebar-info"
          aria-label={`${title} — info`}
        >
          <Icon src="info" size={13} />
        </span>
      </Tooltip.Trigger>
      <Tooltip.Content side="right" className="ui-tooltip-content--panel">
        <div className="flex flex-col gap-1 p-3 text-xs">
          <p className="font-medium">{title}</p>
          <p className="text-muted-foreground">{body}</p>
        </div>
      </Tooltip.Content>
    </Tooltip>
  )
}

export default TranslationSidebarInfo
